import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ScrollRestoration } from 'react-router-dom';

import StepTab from 'components/new_ui/Tabs/StepTab';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Members/Context';

import Log from './Log';
import Preview from './Preview';

export default function Index({ members }) {
  const { dispatch, actions, state } = useContext();
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    const params = {
      members,
      only_validate: true,
    };

    actions.fileImport(
      dispatch,
      state.enterpriseId,
      params,
      (data) => {
        setLogs(data);
      },
    );
  }, []);

  if (logs) {
    const membersWithStatus = members.map((member) => (
      { ...member, status: logs.find((log) => log.email === member['Work Email'])?.member_status }
    ));

    if (logs.some((log) => log.status === 'error')) {
      return (
        <>
          <StepTab total={3} current={2} />

          <Log members={membersWithStatus} logs={logs} />
        </>
      );
    }

    return (
      <>
        <StepTab total={3} current={2} />

        <Preview members={membersWithStatus} />
      </>
    );
  }

  return (
    <>
      <StepTab total={3} current={2} />

      <div className="content">
        <section>
          <LoadingPlaceholder className="my-5" />
        </section>
      </div>

      <ScrollRestoration />
    </>
  );
}

Index.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
};
